import { useQuery } from "@tanstack/react-query"
import { getRfqBuyerToAdminById } from "@/lib/api/rfq.api"
import { useAuthStore } from "@/store/auth.store"

export function useGetRfqBuyerToAdminById(id: string) {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["buyer-rfq-detail", id],
    queryFn: () => getRfqBuyerToAdminById(id, accessToken!),
    enabled: !!accessToken && !!id,
    staleTime:0,
  })
}
